import UserDetail from './UserDetail';

export default UserDetail;
export * from './types'; 